module.exports = __webpack_public_path__ + "img/1510953914.4deb9cbe.jpg";